import React from 'react';
export function StickyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-red text-white py-3 px-4 shadow-lg tracking-wide flex justify-between items-center" data-id="element-321">
      <div className="text-sm md:text-base font-bold animate-pulse" data-id="element-322">
        ⚠️ OFERTA LIMITADA: $49.990 → $19.900 — ACCESO DE POR VIDA
      </div>
      <a href="[CART_LINK]" className="text-xs md:text-sm font-bold bg-white text-brand-red px-3 py-1 rounded-full hover:bg-gray-100 transition-colors whitespace-nowrap ml-4" data-id="element-323">
        COMPRAR AHORA →
      </a>
    </div>;
}